import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  SwipeableDrawer,
  Tooltip,
} from '@mui/material';
import {
  AccountBalanceRounded,
  ArrowBack,
  CalendarTodayRounded,
  CloseRounded,
  EditRounded,
  InsertDriveFileRounded,
  ListAltRounded,
  RemoveCircleRounded,
  SecurityOutlined,
  VpnKeyRounded,
} from '@mui/icons-material';

import dayjs from 'dayjs';

import { FormCriarEmpresa } from '../FormCriarEmpresa';

import {
  Container,
  Boards,
  Div,
  Header,
  HeaderEdit,
  Page,
  SectionBoard,
  SectionCompanies,
  SectionDetails,
  Title,
  Content,
  TitleBoard,
  TitleCompany,
} from './styles';
import TenLogo2 from '../../../assets/horizontal-blue-logo.svg';

import {
  Account,
  activeCompanyRequest,
  Board,
  Company,
  getAccountByIdRequest,
  getActiveBoardsByCompanyId,
  getCompanyByIdRequest,
  removeCompanyRequest,
  Tokens,
  User,
} from '../../../services/requests';
import { createLogRequest } from '../../../services/requests/app-logs/utils';

import useAuthStore from '../../../store/auth';
import useCompanyStore from '../../../store/companies';

import { getNichoType } from '../../../utils/companyHelpers';
import { stringAvatar } from '../../../utils/avatarGenerator';

import { LoadingBackdrop } from '../../../components/LoadingBackdrop';
import { LogoCompanies } from '../../../components/LogoCompanies';

dayjs().format();

export const DetalhesEmpresa = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state: companyNameByStateLocation } = useLocation();

  const user = useAuthStore(state => state.user);
  const setUser = useAuthStore(state => state.setUserAuthenticated);
  const tokens = useAuthStore(state => state.tokens);
  const setMenuSelected = useAuthStore(state => state.setMenuSelected);
  const companies = useCompanyStore(state => state.companies);
  const setSelectedCompany = useCompanyStore(state => state.setSelectedCompany);

  const [empresa, setEmpresa] = useState<Company>({
    id: '',
    name: '',
    doc: '',
    niche: 'NT8',
    status: false,
    account_id: '',
    logo_url: null,
    mfa_required: true,
    users: [],
    users_ids: [],
    boards: [],
    boards_ids: [],
  } as Company);
  const [listagemMembrosEmpresa, setListagemMembrosEmpresa] = useState<User[]>(
    [],
  );
  const [listagemAdminsEmpresa, setListagemAdminsEmpresa] = useState<User[]>(
    [],
  );
  const [openEdit, setOpenEdit] = useState(false);
  const [openModalDesactiveCompany, setOpenModalDesactiveCompany] =
    useState(false);
  const [statusCompany, setStatusCompany] = useState('ativo');
  const [listagemBoards, setListagemBoards] = useState<Board[]>([]);
  const [loading, setLoading] = useState(false);
  const [loadingChangeCompany, setLoadingChangeCompany] = useState(false);
  const [account, setAccount] = useState<Account>();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingText, setIsLoadingText] = useState('Carregando Informações');

  let searchForBoards = '';

  const loadAccount = useCallback(async () => {
    const response = await getAccountByIdRequest(empresa?.account_id as string);

    if (response?.status === 200) {
      setAccount(response?.data);
    }
  }, [empresa?.account_id]);

  useEffect(() => {
    if (empresa?.account_id) {
      loadAccount();
    }
  }, [empresa?.account_id]);

  const removeDuplicates = (users: User[]) => {
    const seenIds = new Set();

    const uniqueUsers = users?.filter((userFilt: User) => {
      if (userFilt?.id) {
        if (!seenIds.has(userFilt?.id)) {
          seenIds.add(userFilt?.id);
          return true;
        }
      }

      return false;
    });

    return uniqueUsers;
  };

  const getCompany = useCallback(async (id: string) => {
    try {
      setLoading(true);

      const response = await getCompanyByIdRequest(id);

      if (response?.status === 200) {
        setStatusCompany(response?.data?.status ? 'ativo' : 'desativado');
        setListagemBoards(
          response?.data?.boards?.length > 0 ? [...response.data.boards!] : [],
        );

        const users = response?.data?.users?.filter(
          (u: User) => u.profile !== 'UN2',
        );
        const admins = response?.data?.users?.filter(
          (u: User) => u.profile === 'UN2' || u?.profile === 'UN1',
        );

        const usersFiltered = removeDuplicates(users);
        const adminsFiltered = removeDuplicates(admins);

        const foundedCompany = {
          ...response?.data,
        };

        setEmpresa({ ...foundedCompany });
        setListagemAdminsEmpresa([...adminsFiltered]);
        setListagemMembrosEmpresa([...usersFiltered]);
      }
    } catch (error) {
      console.log('Error getCompany', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (params?.id) {
      getCompany(params?.id);
    }
  }, [params]);

  async function loadBoards() {
    try {
      setLoading(true);
      const responseActives = await getActiveBoardsByCompanyId(
        params?.id as string,
        searchForBoards,
        user?.id as string,
      );

      if (responseActives?.status === 200) {
        setListagemBoards(responseActives?.data);
      }
    } catch (error) {
      console.error('Error LoadBoards', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (user && params?.id) {
      loadBoards();
    }
  }, [user, params]);

  const handleCloseEditAccount = () => {
    setOpenEdit(false);
  };

  const handleChangeStatusCompanyToActive = async () => {
    try {
      console.log(empresa?.status);
      const response = await activeCompanyRequest(params?.id as string);

      if (response?.status === 200) {
        setStatusCompany('ativo');
        setEmpresa({
          ...empresa,
          status: true,
        });
        toast.success('Empresa editada com sucesso');
      }
    } catch (error) {
      console.error('handleUploadFile Error', error);
      toast.error(
        'Ocorreu um erro ao alterar o status da empresa, Tente novamente mais tarde',
      );
    } finally {
      setOpenModalDesactiveCompany(false);
      setLoading(false);
    }
  };

  const handleChangeStatusCompanyToInactive = async () => {
    try {
      console.log(empresa?.status);
      const response = await removeCompanyRequest(params?.id as string);

      if (response?.status === 200) {
        const companiesActive = companies?.filter(c => c.id !== params?.id);
        const firstCompanyActive =
          companiesActive?.length > 0 ? companiesActive[0] : {};
        setSelectedCompany(firstCompanyActive as any);

        setStatusCompany('desativado');
        setEmpresa({
          ...empresa,
          status: false,
        });
        toast.success('Empresa editada com sucesso');
      }
    } catch (error) {
      console.error('handleUploadFile Error', error);
      toast.error(
        'Ocorreu um erro ao alterar o status da empresa, Tente novamente mais tarde',
      );
    } finally {
      setOpenModalDesactiveCompany(false);
      setLoading(false);
    }
  };

  const handleChangeStatusCompany = async () => {
    setLoading(true);

    if (empresa?.status) {
      await handleChangeStatusCompanyToInactive();
    } else {
      await handleChangeStatusCompanyToActive();
    }
  };

  const handleNavigate = useCallback(
    async (company: Company, to: string) => {
      try {
        setLoadingChangeCompany(true);
        setSelectedCompany(company);

        const userInCompany = company?.users?.find(u => u.doc === user?.doc);

        if (userInCompany) {
          const userEdited = {
            ...user,
            profile: userInCompany?.profile,
          };

          setUser(userEdited as User, tokens as Tokens);
        } else {
          setUser(user as User, tokens as Tokens);
        }

        if (to === 'members') {
          await createLogRequest({
            action: 'Acessou',
            company_id: company?.id as string,
            description: `Acessou a aba de gestão de usuários na empresa ${company?.name}`,
            local: 'Acessos',
            name: user?.name as string,
            user_id: user?.id as string,
          });

          navigate('/home/gestao-usuarios');
        }

        if (to === 'boards') {
          await createLogRequest({
            action: 'Acessou',
            company_id: company?.id as string,
            description: `Acessou a aba de boards na empresa ${company?.name}`,
            local: 'Acessos',
            name: user?.name as string,
            user_id: user?.id as string,
          });

          navigate('/home/boards');
        }

        if (to === 'company') {
          await createLogRequest({
            action: 'Acessou',
            company_id: company?.id as string,
            description: `Acessou a plataforma na empresa ${company?.name}`,
            local: 'Acessos',
            name: user?.name as string,
            user_id: user?.id as string,
          });

          navigate('/home/reunioes');
        }
        setMenuSelected('portal');
      } catch (err) {
        console.log(err);
      } finally {
        setLoadingChangeCompany(false);
      }
    },
    [navigate, setMenuSelected, setSelectedCompany, setUser, tokens, user],
  );

  const editDados = () => (
    <Box
      width="480px"
      margin="20px"
      height="100%"
      display="flex"
      flexDirection="column"
    >
      <HeaderEdit>
        <IconButton onClick={() => setOpenEdit(false)}>
          <CloseRounded />
        </IconButton>
        <Box className="edit-dados">Editar Dados</Box>
      </HeaderEdit>
      <Page height="100%" display="flex" flexDirection="column">
        <FormCriarEmpresa
          accountId={params?.id as string}
          companyId={empresa?.id}
          company={empresa}
          setCompany={setEmpresa}
          handleReset={handleCloseEditAccount}
          setIsLoading={setIsLoading}
          setIsLoadingText={setIsLoadingText}
        />
      </Page>
    </Box>
  );

  return (
    <Container>
      {isLoading && (
        <LoadingBackdrop
          text={isLoadingText}
          component=""
          loading={isLoading}
        />
      )}
      {loading && (
        <LoadingBackdrop
          text="Alterando status da empresa"
          component={empresa?.name}
          loading={loading}
        />
      )}
      {loadingChangeCompany && (
        <LoadingBackdrop
          text="Alterando para empresa"
          component={empresa?.name}
          loading={loadingChangeCompany}
        />
      )}
      <Header>
        <Button
          className="btn-back"
          variant="outlined"
          onClick={() => navigate(-1)}
        >
          <ArrowBack /> Voltar
        </Button>
        <Box sx={{ width: '60vw' }}>
          <Title>
            {companyNameByStateLocation} / {empresa?.name}
          </Title>
        </Box>
      </Header>
      <SectionDetails>
        <Box display="flex" alignItems="start" justifyContent="space-between">
          <Box display="flex" flexDirection="column">
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="start"
              gap="20px"
            >
              <LogoCompanies
                url={empresa?.logo_url ? empresa?.logo_url : TenLogo2}
                boxWidth="100%"
                height="100%"
                maxWidth="100%"
                width="150px"
                justifyContent="start"
              />
              <Box
                sx={{ width: '60vw' }}
                color={statusCompany === 'ativo' ? '#000000' : '#d62237'}
              >
                <Tooltip title={empresa?.name}>
                  <TitleCompany>
                    {empresa?.fancy_name ?? empresa?.name}
                  </TitleCompany>
                </Tooltip>
              </Box>
            </Box>
            <Box display="flex" flexDirection="column" gap="10px">
              <Box className="item-text">
                <VpnKeyRounded /> ID da Empresa: {empresa?.id}
              </Box>

              <Box className="item-text">
                <CalendarTodayRounded /> Cadastrada em{' '}
                {dayjs(empresa?.created_at).format('DD/MM/YYYY HH:mm')}
              </Box>
              <Box className="item-text">
                <InsertDriveFileRounded /> CNPJ: {empresa?.doc}
              </Box>
              <Box className="item-text">
                <ListAltRounded /> Nicho: {getNichoType(empresa?.niche as any)}
              </Box>
              <Box className="item-text">
                <SecurityOutlined /> MFA{' '}
                {empresa?.mfa_required ? 'habilitado' : 'desabilitado'}
              </Box>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gap="10px">
            {statusCompany === 'ativo' &&
              (user?.profile === 'UN1' || user?.profile === 'UN2' ? (
                <Button
                  variant="contained"
                  className="btn-edit"
                  onClick={() => handleNavigate(empresa, 'company')}
                >
                  <AccountBalanceRounded /> Acessar empresa
                </Button>
              ) : (
                ''
              ))}
            <React.Fragment key="right">
              {statusCompany === 'ativo' &&
                (user?.profile === 'UN1' || user?.profile === 'UN2' ? (
                  <Button
                    variant="contained"
                    className="btn-edit"
                    onClick={() => setOpenEdit(true)}
                  >
                    <EditRounded /> Editar Dados
                  </Button>
                ) : (
                  ''
                ))}
            </React.Fragment>
            <SwipeableDrawer
              anchor="right"
              open={openEdit}
              onClose={() => setOpenEdit(false)}
              onOpen={() => setOpenEdit(true)}
              ModalProps={{
                keepMounted: true,
              }}
            >
              {editDados()}
            </SwipeableDrawer>
            {statusCompany === 'ativo' ? (
              user?.profile === 'UN1' || user?.profile === 'UN2' ? (
                <Button
                  variant="outlined"
                  color="error"
                  className="btn-adm"
                  type="button"
                  onClick={() => setOpenModalDesactiveCompany(true)}
                >
                  <RemoveCircleRounded /> Desativar empresa
                </Button>
              ) : (
                ''
              )
            ) : account?.status ? (
              <Button
                variant="contained"
                color="error"
                className="btn-adm"
                type="button"
                onClick={() => setOpenModalDesactiveCompany(true)}
              >
                Ativar empresa
              </Button>
            ) : (
              <Tooltip title="Não é possível ativar a empresa, conta desativada">
                <Box>
                  <Button
                    variant="contained"
                    color="error"
                    className="btn-adm"
                    type="button"
                    disabled
                    onClick={() => setOpenModalDesactiveCompany(true)}
                  >
                    Ativar empresa
                  </Button>
                </Box>
              </Tooltip>
            )}
            <Dialog
              open={openModalDesactiveCompany}
              onClose={() => setOpenModalDesactiveCompany(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              id="dialog-main"
              PaperProps={{
                sx: {
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                },
              }}
            >
              <DialogTitle
                id="alert-dialog-title"
                sx={{
                  fontWeight: '500',
                  fontSize: '20px',
                  color: '#000000',
                  padding: 0,
                }}
              >
                {empresa?.status ? 'Desativar empresa' : 'Ativar empresa'}
              </DialogTitle>
              <DialogContent sx={{ padding: '0' }}>
                <DialogContentText
                  id="alert-dialog-description"
                  sx={{
                    color: 'rgba(0, 0, 0, 0.54)',
                    fontWeight: '400',
                    fontSize: '16px',
                  }}
                >
                  {empresa?.status
                    ? 'Ao desativar a empresa, nenhum usuário conseguirá acessar suas informações e arquivos. Deseja prosseguir?'
                    : 'Ao ativar a empresa, todos os usuários da empresa conseguirão acessar suas informações e arquivos. Deseja prosseguir?'}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => setOpenModalDesactiveCompany(false)}
                  variant="text"
                  sx={{
                    color: '#9E9E9E',
                    padding: '6px 22px',
                    width: '124px',
                    height: '38px',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  Cancelar
                </Button>
                <Button
                  onClick={() => handleChangeStatusCompany()}
                  autoFocus
                  color={empresa?.status ? 'error' : 'primary'}
                  variant="contained"
                  sx={{
                    padding: '6px 22px',
                    width: '124px',
                    height: '38px',
                    fontWeight: '500',
                    fontSize: '14px',
                  }}
                >
                  {empresa?.status ? 'Desativar' : 'Ativar'}
                </Button>
              </DialogActions>
            </Dialog>
          </Box>
        </Box>
      </SectionDetails>
      <SectionDetails>
        <Div>
          <Title>Membros</Title>
          <React.Fragment key="right">
            {empresa?.status &&
              (user?.profile === 'UN1' || user?.profile === 'UN2' ? (
                <Button
                  variant="contained"
                  className="btn-add-companie"
                  onClick={() => handleNavigate(empresa, 'members')}
                >
                  Gerenciar membros
                </Button>
              ) : null)}
          </React.Fragment>
        </Div>
        <SectionCompanies marginTop="20px">
          {listagemAdminsEmpresa.length < 1 ? (
            <Box className="section-board">
              Nenhum membro adicionado até o momento.
            </Box>
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              gap="20px"
            >
              <Box
                display="flex"
                flexDirection="row"
                gap="20px"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Box className="text">Admins: </Box>
                <Box
                  marginLeft="12px"
                  display="flex"
                  flexDirection="row"
                  gap="20px"
                  justifyContent="flex-start"
                >
                  <AvatarGroup max={10}>
                    {listagemAdminsEmpresa?.map(e => (
                      <Tooltip key={e?.id} title={e?.name} arrow>
                        {e?.avatar_url ? (
                          <Avatar sx={{ width: '40px' }}>
                            <img
                              src={e?.avatar_url as string}
                              alt="Foto de perfil"
                              style={{ width: '100%' }}
                            />
                          </Avatar>
                        ) : (
                          <Avatar
                            {...stringAvatar(e.name!)}
                            sx={{ width: '40px' }}
                          />
                        )}
                      </Tooltip>
                    ))}
                  </AvatarGroup>
                </Box>
              </Box>
              <Box
                display="flex"
                flexDirection="row"
                gap="20px"
                alignItems="center"
                justifyContent="flex-start"
              >
                <Box className="text">Membros: </Box>
                <AvatarGroup max={10}>
                  {listagemMembrosEmpresa?.map(e => (
                    <Tooltip key={e?.id} title={e?.name} arrow>
                      {e?.avatar_url ? (
                        <Avatar sx={{ width: '40px' }}>
                          <img
                            src={e?.avatar_url as string}
                            alt="Foto de perfil"
                            style={{ width: '100%' }}
                          />
                        </Avatar>
                      ) : (
                        <Avatar
                          {...stringAvatar(e.name!)}
                          sx={{ width: '40px' }}
                        />
                      )}
                    </Tooltip>
                  ))}
                </AvatarGroup>
              </Box>
            </Box>
          )}
        </SectionCompanies>
      </SectionDetails>
      <SectionDetails>
        <Div>
          <Title>Boards</Title>
          <React.Fragment key="right">
            {empresa?.status &&
              (user?.profile === 'UN1' || user?.profile === 'UN2' ? (
                <Button
                  variant="contained"
                  className="btn-add-companie"
                  onClick={() => handleNavigate(empresa, 'boards')}
                >
                  Gerenciar Boards
                </Button>
              ) : null)}
          </React.Fragment>
        </Div>
        <SectionCompanies marginTop="20px">
          {listagemBoards?.length < 1 ? (
            <Box className="section-board">
              Nenhum board adicionado até o momento.
            </Box>
          ) : (
            <SectionBoard>
              {listagemBoards?.map(e => (
                <Boards key={e?.id} sx={{ borderColor: e.color }}>
                  <Content>
                    <Tooltip title={e.title} arrow>
                      <TitleBoard>{e?.title}</TitleBoard>
                    </Tooltip>
                  </Content>
                  <Box className="text-member-board">
                    {e?.members?.length}{' '}
                    {e?.members?.length === 1 ? 'membro' : 'membros'}
                  </Box>
                </Boards>
              ))}
            </SectionBoard>
          )}
        </SectionCompanies>
      </SectionDetails>
    </Container>
  );
};
